import React, { Suspense, useMemo } from 'react';
import { ACCEPT_IMAGES } from '../../constants';

type Props = {
  file: File | { url: string; type: string };
  className?: string;
  onRemove?: () => void;
};

const IconButton = React.lazy(() =>
  new Promise((resolve) => {
    setTimeout(resolve, 100);
  }).then(() => import('../IconButton').then(module => ({ default: module.IconButton })))
);

export function FileView({ file, className = '', onRemove }: Props) {
  const url = useMemo(() => {
    const urlFile = 'url' in file ? file?.url : URL.createObjectURL(file);
    return urlFile;
  }, [file]);

  return (
    <div className="h-full relative flex-shrink-0">
      {onRemove && (
        <Suspense fallback={<></>}>
          <IconButton
            onClick={onRemove}
            icon="close"
            className="absolute top-0 right-0 z-[1]"
            transparent
          />
        </Suspense>
      )}
      {ACCEPT_IMAGES.includes(file?.type) ? (
        <img alt="" src={url} className={className} />
      ) : (
        <video className={`${className}`} autoPlay muted playsInline loop>
          <source src={url} />
        </video>
      )}
    </div>
  );
}
